export default {
  home: {
    label: {
      notes: 'Label of home link in main navigation',
      message: 'Home',
    },
  },
  fleet: {
    label: {
      notes: 'Label of fleet link in main navigation',
      message: 'Fleet',
    },
  },
  shop: {
    label: {
      notes: 'Label of shop link in main navigation',
      message: 'E-COM',
    },
  },
  admin: {
    label: {
      notes: 'Label of administration link in main navigation',
      message: 'Admin',
    },
  },
};
